// eslint-disable-next-line boundaries/element-types, no-restricted-imports
import { FilesUploadDropzone } from "../features/files-uploader";

export default FilesUploadDropzone;
